import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Navbar, Nav, Container } from "react-bootstrap";
import { useAuth0 } from "@auth0/auth0-react";
import NavLink from "./NavLink";
import { 
  NAVBAR_IMAGE_LOGO_PATH,   
  LINKEDIN_ICON_PATH,
  FACEBOOK_ICON_PATH,
  FOURSQUARE_ICON_PATH, 
} from "../../lib/data";


const PublicNavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, loginWithRedirect } = useAuth0();

  const [activeLink, setActiveLink] = useState("home");
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const navbarRef = useRef(null);
  const toggleRef = useRef(null);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/admin/home-page-details');
    }
  }, [isAuthenticated]);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  /* CLOSE MENU ON OUTSIDE CLICK */

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!expanded) return;

      if (
        navbarRef.current &&
        !navbarRef.current.contains(e.target) &&
        toggleRef.current &&
        !toggleRef.current.contains(e.target)
      ) {
        setExpanded(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [expanded]);

  const onUpdateActiveLink = (value, page) => {
    setActiveLink(value);
    setExpanded(false); // close mobile menu

    if (page) navigate(page);
  };

  const links =
    location.pathname.split("/")[1] !== "services"
      ? [
          ["home", null, "Home", "#home"],
          ["services", null, "Services", "#services"],
          ["mission", null, "Mission", "#mission"],
          ["team", null, "Team", "#team"],
          ["gallery", null, "Gallery", "#gallery"],
        ]
      : [];

  /* 
  Note: The collapseOnSelect property needs to be used in conjunction with adding the eventKey props to the 
        Nav.Link elements for the collapse on click to work in mobile view.
        */
  return (
    <Navbar
      ref={navbarRef}
      expanded={expanded}
      onToggle={(value) => setExpanded(value)}
      as="nav"
      aria-label="Primary navigation"
      collapseOnSelect
      expand="md"
      className={scrolled ? "scrolled" : ""}
      id="#navbar_id"
    >
      <Container>
        <Navbar.Brand href="/" aria-label="All About Hair home">
          <img src={NAVBAR_IMAGE_LOGO_PATH} alt="All About Hair logo" />
        </Navbar.Brand>

        <Navbar.Toggle
          ref={toggleRef}
          aria-label="Toggle navigation menu"
          aria-controls="primary-navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>

        <Navbar.Collapse id="primary-navigation">
          <Nav className="ms-auto" role="menubar">
            {links.map(([title, page, text, href], idx) => (
              <div key={idx}>
                <NavLink
                  role="menuitem"
                  key={idx}
                  activeLink={activeLink}
                  title={title}
                  onClick={() =>
                    page
                      ? onUpdateActiveLink(title, page)
                      : onUpdateActiveLink(title)
                  }
                  href={href}
                >
                  {text}
                </NavLink>
              </div>
            ))}

            {!isAuthenticated && (
              <NavLink title="login" onClick={loginWithRedirect} role="menuitem">
                Log In
              </NavLink>
            )}

            {/* <Nav.Link href="#prices" className={activeLink === 'prices' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('prices')}>Prices</Nav.Link> */}
            {/* <Nav.Link href="#contact" className={activeLink === 'contact' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('contact')}>Contact</Nav.Link> */}
          </Nav>
          {!isAuthenticated && (
            <span className="navbar-text">
              <div className="social-icon" aria-label="Social media links">
                <a href="#home" aria-label="Visit our LinkedIn">
                  <img src={LINKEDIN_ICON_PATH} alt="" aria-hidden="true" tabIndex="-1" />
                </a>
                <a href="#home" aria-label="Visit our Facebook">
                  <img src={FACEBOOK_ICON_PATH} alt="" aria-hidden="true" tabIndex="-1" />
                </a>
                <a href="#home" aria-label="Visit our Foursquare">
                  <img src={FOURSQUARE_ICON_PATH} alt="" aria-hidden="true" tabIndex="-1" />
                </a>
              </div>
              {location.pathname.split("/")[1] !== "services" ? (
                <Nav.Link href="#contact" className="navbar-lets-connect-btn" role="menuitem">
                  <button type="button" className="vvd">
                    <span>Let’s Connect</span>
                  </button>
                </Nav.Link>
              ) : null}
            </span>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default PublicNavBar;
